/* ROCKBROS NL BF Hot Collections v4 — Enterprise native desktop slider; mobile expand/collapse; no navigation. */
(() => {
  if (window.__rbnlBFHotCollectionsV4) return;
  window.__rbnlBFHotCollectionsV4 = true;

  const reduced = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const currency = (cents,iso) => new Intl.NumberFormat('nl-NL',{style:'currency',currency:iso||'EUR'}).format((Number(cents)||0)/100);

  function initialize(root) {
    if (!root || root.dataset.hotReady==='v4') return;
    root.dataset.hotReady='v4';
    const tabs=[...root.querySelectorAll('[data-hot-tab]')];
    const panels=[...root.querySelectorAll('[data-hot-panel]')];
    if (!tabs.length || !panels.length) return;

    function updateCarousel(panel) {
      const carousel=panel?.querySelector('carousel-slider');
      if(!carousel)return;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if(typeof carousel.handleBreakpointChange==='function' && carousel.slider) carousel.handleBreakpointChange();
      }));
    }

    function select(tab,shouldFocus=false) {
      const key=tab.dataset.hotTab;
      tabs.forEach(t => {
        const active = t===tab;
        t.classList.toggle('is-active',active);
        t.setAttribute('aria-selected',String(active));
        t.tabIndex=active?0:-1;
      });
      panels.forEach(panel => {
        const active=panel.dataset.hotPanel===key;
        panel.hidden=!active;
        if(active)updateCarousel(panel);
      });
      if(shouldFocus){
        tab.focus({preventScroll:true});
        tab.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'nearest',inline:'nearest'});
      }
    }

    function toggleAll(btn) {
      const panel=btn.closest('[data-hot-panel]');
      if(!panel)return;
      const expanded=!panel.classList.contains('sbf-hot__panel--expanded');
      panel.classList.toggle('sbf-hot__panel--expanded',expanded);
      btn.setAttribute('aria-expanded',String(expanded));
      const label=btn.querySelector('[data-hot-toggle-text]');
      if(label)label.textContent=expanded?btn.dataset.closeLabel:btn.dataset.openLabel;
      if(!expanded && window.innerWidth<750){
        const top=panel.querySelector('.sbf-hot__panel-title');
        // After collapsing a long product list, return customers to its heading.
        requestAnimationFrame(()=>{
          const rect=top?.getBoundingClientRect();
          if(rect && rect.top<72) top.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'start'});
        });
      }
    }

    function openQuick(opener) {
      const card=opener.closest('.nlo-card');
      if(!card)return;
      const url=new URL(card.dataset.productUrl||'',location.origin);
      if(card.dataset.cardSelectedVariant)url.searchParams.set('variant',card.dataset.cardSelectedVariant);
      if(window.RbnlQuickView?.open)window.RbnlQuickView.open(root,url.href,opener);
      else location.assign(url.href);
    }
    function changeVariant(button) {
      const card=button.closest('.nlo-card');
      if(!card)return;
      const price=Number(button.dataset.price),compare=Number(button.dataset.compare);
      card.dataset.cardSelectedVariant=button.dataset.variantId;
      const input=card.querySelector('[data-hot-variant-input]');
      if(input)input.value=button.dataset.variantId;
      const image=card.querySelector('.nlo-card__photo');
      if(image&&button.dataset.image){image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=card.getAttribute('aria-label')||''}
      const current=card.querySelector('[data-hot-price]'),prior=card.querySelector('[data-hot-compare]');
      if(current)current.textContent=currency(price,root.dataset.rbnlCurrency);
      if(prior){prior.hidden=!(compare>price);prior.textContent=compare>price?currency(compare,root.dataset.rbnlCurrency):'';}
      const badge=card.querySelector('[data-hot-badge]');
      const discount=compare>price&&compare>0?Math.round(100*(compare-price)/compare):0;
      if(badge){badge.hidden=discount<=0;badge.textContent=discount>0?'−'+discount+'% KORTING':''}
      card.querySelectorAll('[data-hot-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }

    root.addEventListener('click',e=>{
      const tab=e.target.closest('[data-hot-tab]');
      if(tab&&root.contains(tab)){e.preventDefault();select(tab);return}
      const variant=e.target.closest('[data-hot-variant]');
      if(variant&&root.contains(variant)){changeVariant(variant);return}
      const quick=e.target.closest('[data-hot-open-product]');
      if(quick&&root.contains(quick)){e.preventDefault();openQuick(quick);return}
      const toggle=e.target.closest('[data-hot-toggle]');
      if(toggle&&root.contains(toggle)){toggleAll(toggle);return}
    });

    tabs.forEach((tab,index)=>tab.addEventListener('keydown',e=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
      e.preventDefault();
      let i=index;
      if(e.key==='ArrowRight')i=(index+1)%tabs.length;
      else if(e.key==='ArrowLeft')i=(index+tabs.length-1)%tabs.length;
      else if(e.key==='Home')i=0;
      else i=tabs.length-1;
      select(tabs[i],true);
    }));
    root.addEventListener('shopify:block:select',e=>{
      const tab=e.target?.closest?.('[data-hot-tab]');
      if(tab)select(tab,true);
    });
    // Match any panel selection made in the Shopify editor.
    panels.forEach(p=>{if(!p.hidden)updateCarousel(p)});
  }

  function mount(scope=document){
    if(scope.matches?.('[data-sbf-hot]'))initialize(scope);
    scope.querySelectorAll?.('[data-sbf-hot]').forEach(initialize);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(),{once:true});
  else mount();
  document.addEventListener('shopify:section:load',e=>mount(e.target));
})();